<template lang="pug">
v-card(flat)
  v-card-text
    v-row(v-if="initialText")
      v-col
        p.text-edit(v-html="initialText")
    v-row
      v-col
        v-btn.grey.darken-2(depressed text @click.prevent="dialog = true")
          v-icon(left) mdi-playlist-edit
          | {{label}} ändern
        
        
  v-dialog(
    width="740"
    v-model="dialog"
    @click:outside="closeDialog"
    transition="scroll-y-transition"
    :overlay-opacity="0.9"
  )
    v-card
      v-toolbar.transparent(flat)
        v-app-bar-nav-icon(@click="closeDialog")
          v-icon mdi-close
        v-toolbar-title Text Editieren 2
      v-divider
      v-card-text.mt-4
        vue-editor(
          v-model="initialText" 
          width="600"
          :editor-toolbar="customToolbar"
          @image-added="handleImageAdded"
        )
        //- useCustomImageHandler
      v-card-actions
        v-spacer
        v-btn.primary(@click="closeDialog") OK
        v-spacer
</template>


<script>
import { VueEditor, Quill } from "vue2-editor";

// Specify Quill fonts
var fontList = ['Roboto', 'Messapia Bold', 'DMMono-Regular', 'Srisakdi Bold', 'Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana'];
var fontNames = fontList.map(font => getFontName(font));
var fonts = Quill.import('attributors/class/font');
fonts.whitelist = fontNames;
console.log("FONT name", fontNames, fontList)

/**
 * ADD CUSTOM ATO BUTTON
 */
let Block = Quill.import('blots/block');
var icons = Quill.import('ui/icons');

class MainButtonBlock extends Block {
  static create() {
    let node = super.create();
    node.setAttribute('class', this.className);
    return node;
  }
  static formats(domNode) {
    return true;
  }
}

MainButtonBlock.blotName = 'main-button-block';
MainButtonBlock.className = "main-button-block"
MainButtonBlock.tagName = "span"
Quill.register(MainButtonBlock);
icons['main-button-block'] = "🎆"

/**
 * ADD CUSTOM ATO BUTTON 2
 */
let Block2 = Quill.import('blots/block');

class MainButtonBlockPrime extends Block2 {
  static create() {
    let node = super.create();
    node.setAttribute('class', this.className);
    return node;
  }
  static formats(domNode) {
    return true;
  }
}

MainButtonBlockPrime.blotName = 'main-button-block-prime';
MainButtonBlockPrime.className = "main-button-block-prime"
MainButtonBlockPrime.tagName = "span"
Quill.register(MainButtonBlockPrime);
icons['main-button-block-prime'] = "🌠"


// Add fonts to CSS style
Quill.register(fonts, true);
var fontStyles = "";
fontList.forEach(function(font) {
    var fontName = getFontName(font);
    fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
        "content: '" + font + "';" +
        "font-family: '" + font + "', sans-serif;" +
        "}" +
        ".ql-font-" + fontName + "{" +
        " font-family: '" + font + "', sans-serif;" +
        "}";
});

const node = document.createElement('style');
node.innerHTML = fontStyles;
document.body.appendChild(node);

// Generate code-friendly font names
function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}

var Link = Quill.import('formats/link');
class MyLink extends Link {
  static create(value) {
    let node = super.create(value);
    value = this.sanitize(value);
    console.log("here..", value, node, this.sanitize)
    if( value.startsWith("https:") || value.startsWith("http:")){
      node.setAttribute('target', '_blank')
    }else if(value.startsWith("www.")){
      value = "https://" + value
      node.setAttribute('target', '_blank')
    }else{
      node.setAttribute('target', '_self')
    }

    node.setAttribute('href', value);
    return node;
  }
}

Quill.register(MyLink);

import singleUpload from '@/apollo/upload.gql'

export default {
  components: { VueEditor },
  props: [ 
    'text',
    'label',
    'target'
  ],

  data() {
    return {
      initialText: this.text,
      dialog: false,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'main-button-block','main-button-block-prime', 'code-block', 'link'],
        ['image', 'video'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'font': fonts.whitelist }],
        [{ 'align': [] }],
        
        [{
        'color': ['#E53629', '#F29A94', '#111', '#FFF8E7', '#F00', '#0F0', '#00F', '#000', '#FFF']
        }],
        ['clean']
      ],
    }
  },

  watch: {
    initialText(newVal) {
      this.$emit('update:text', newVal)
    },

    dialog(newVal){
      if(newVal){
        this.initialText = this.text
      }
    }
  },
  methods: {
     handleImageAdded: async function(file, Editor, cursorLocation, resetUploader) {
       console.log("handle...");
      try{
        console.log("initiating...", file);
        const result = await this.$apollo.mutate({
          mutation: singleUpload,
          variables: {
            file: file,
          }
        })
        const imgPath = `${process.env.VUE_APP_CDN_URL}/${result.data.singleUpload.filename}`
        const fullImgPath = imgPath + "-640w.webp"
        console.log("image loading true", fullImgPath);

        Editor.insertEmbed(cursorLocation, "image", fullImgPath);
        resetUploader();
      }catch(err){
        console.log("error image handle", err);
      }

      // var formData = new FormData();
      // formData.append("image", file);

      // axios({
      //   url: "https://fakeapi.yoursite.com/images",
      //   method: "POST",
      //   data: formData
      // })
      //   .then(result => {
      //     let url = result.data.url; // Get url from response
      //     resetUploader();
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },

    closeDialog(){
      this.dialog = false
    }
  }
}
</script>
